import { render, staticRenderFns } from "./GroupSessionsTab.vue?vue&type=template&id=e8955f4a&"
import script from "./GroupSessionsTab.vue?vue&type=script&lang=js&"
export * from "./GroupSessionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports